import { render, staticRenderFns } from "./registerComponent.vue?vue&type=template&id=200f341f&"
import script from "./registerComponent.vue?vue&type=script&lang=js&"
export * from "./registerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports